import Quill from 'quill';

const MAX_IMAGE_WIDTH = 540;

export default function pasteImage(quill: Quill, imageSrc: string) {
  const range = quill.getSelection(true);
  const img = new Image();
  img.src = imageSrc;
  img.onload = () => {
    const imageWidth = img.width;
    quill.insertEmbed(range.index, 'image', imageSrc, Quill.sources.USER);
    if (imageWidth > MAX_IMAGE_WIDTH) {
      quill.formatText(range.index, 1, 'width', MAX_IMAGE_WIDTH);
    }
    quill.setSelection(range.index + 1, Quill.sources.SILENT);
    quill.history.cutoff();
  }
}